import { apiSlice } from 'api/apiSlice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all supercapstones
    getSuperCapstones: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone/user',
          params: params,
        };
      },
      // transformResponse: (res: any) => res.data,
      providesTags: ['AllSuperCapstones'],
    }),
    getSuperCapstone: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone/user',
          params: params,
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['SuperCapstone'],
    }),
    getSuperCapstoneByPartner: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone/b2b',
          params: params,
        };
      },
      transformResponse: (res: any) => {
        return res;
      },
      providesTags: ['AllSuperCapstones'],
    }),
    getFilter: builder.query<any, void>({
      query: () => {
        return {
          url: '/super-capstone/filter-data',
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['SuperCapstoneFilter'],
    }),
    getUserSuperCapstones: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission',
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['MySuperCapstone'],
    }),
    enrollCapstone: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/',
          method: 'POST',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: [
        'AllSuperCapstones',
        'MySuperCapstone',
        'CurrentSuperCapstone',
      ],
    }),
    addTaskSolution: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/task',
          method: 'PUT',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['MySuperCapstone'],
    }),
    addQuiz: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/quiz',
          method: 'PUT',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['MySuperCapstone'],
    }),
    addSuperFeedback: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/feedback',
          method: 'PUT',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['MySuperCapstone'],
    }),
    addCompleted: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/completed',
          method: 'PUT',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['MySuperCapstone'],
    }),
    addTask2Feedback: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/task2-feedback',
          method: 'PUT',
          body: params,
        };
      },
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['MySuperCapstone'],
    }),
    getTask2FeedbackStatus: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/super-capstone-submission/task2-feedback-status',
          params: { enrollId: params.enrollId },
        };
      },
      transformResponse: (res: any) => res,
      providesTags: ['MySuperCapstone'],
    }),
  }),
});

export const {
  useGetSuperCapstonesQuery,
  useGetSuperCapstoneQuery,
  useGetSuperCapstoneByPartnerQuery,
  useGetFilterQuery,
  useGetUserSuperCapstonesQuery,
  useEnrollCapstoneMutation,
  useAddTaskSolutionMutation,
  useAddQuizMutation,
  useAddSuperFeedbackMutation,
  useAddCompletedMutation,
  useAddTask2FeedbackMutation,
  useGetTask2FeedbackStatusQuery,
} = extendedApiSlice;
